(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	ngModule.controller('OrderDetailController', [ '$scope', '$Orders', '$rootScope', '$Products', 'orderDetails', function ($scope, $Orders, $rootScope, $Products, orderDetails) {

                $scope.orderDetails = orderDetails;

                $scope.save = function() {
                    $scope.orderDetails.$save();
                };

                $scope.editCustomerDetailsMode = false;
                $scope.editPaymentStatusMode = false;

                $scope.paymentStatusOptions = ['Pending','Paid','Refunded', 'Partially Refunded'];

                $scope.editOrderStatusMode = false;
                $scope.editTotalMode = false;

                $scope.orderStatusOptions = ['Open', 'Canceled', 'Filled'];

                $scope.editCustomerInfo = function() {
                    $scope.editCustomerDetailsMode = true;
                };

                $scope.saveCustomerInfo = function() {
                    $scope.save();
                    $scope.editCustomerDetailsMode = false;
                }

                // $scope.addItem = function() {
                //     var scope = $rootScope.$new();
                //     scope.products = $Products.all;
                //
                //     var modal = ModalService.showModal({
                //       scope: scope,
                //       templateUrl: 'directives/orderDetail/addProductForm.html',
                //       controller: function($scope, $element, close) {
                //           $scope.itemTotal = 0;
                //           $scope.itemCount = 0;
                //
                //           $scope.setTotals = function() {
                //               $scope.itemCount = _.reduce($scope.product.properties, function(memo, property){
                //                   return property.purchased ? memo + 1 : memo;
                //               }, 0);
                //
                //               $scope.itemTotal = ($scope.item.basePrice || 0) + _.reduce($scope.product.properties, function(memo, property){
                //                   return property.purchased ? property.purchased.price + memo : 0;
                //               }, 0);
                //
                //               // $scope.itemTotal = $scope.itemTotal * $scope.item.quantity;
                //
                //               console.log('Total for Item', $scope.itemTotal);
                //           };
                //
                //           $scope.$on('selectionChanged', function() {
                //               $scope.setTotals();
                //           });
                //
                //           $scope.$watch('product', function(newValue, oldValue) {
                //               if (newValue !== oldValue) {
                //                   $scope.setTotals();
                //               }
                //           });
                //
                //           $scope.submitForm = function(form, data) {
                //               var item = angular.copy($scope.product);
                //               if (!_.isArray(order.items)) order.items = [];
                //
                //               order.items.unshift(item);
                //
                //               $element.modal('hide');
                //               close(null, 500);
                //           };
                //
                //       }
                //     }).then(function(modal) {
                //         // The modal object has the element built, if this is a bootstrap modal
                //         // you can call 'modal' to show it, if it's a custom modal just show or hide
                //         // it as you need to.
                //         modal.element.modal();
                //     });
                // };
                //
                // $scope.addPackage = function() {
                //     var scope = $rootScope.$new();
                //
                //     /* Attach the order to the modal scope. */
                //     scope.order = $scope.order;
                //
                //     if (!$scope.order.store) {
                //         alert('Sorry, there is no store attached to this order.');
                //         return;
                //     }
                //
                //     /* ensure we have a packages array on the order. */
                //     if (!_.isArray($scope.order.packages)) $scope.order.packages = [];
                //
                //     scope.packages = $scope.order.store.packages || [];
                //
                //     var modal = ModalService.showModal({
                //       scope: scope,
                //       templateUrl: 'directives/orderDetail/addStorePackage.html',
                //       controller: function($scope, $element, close) {
                //           $scope.addPackage = function(data) {
                //               /* Push the package data onto the order packages array. */
                //               scope.order.packages.push(data);
                //
                //               /* Close the modal. */
                //               $element.modal('hide');
                //               close(null, 500);
                //           };
                //       }
                //     }).then(function(modal) {
                //         // The modal object has the element built, if this is a bootstrap modal
                //         // you can call 'modal' to show it, if it's a custom modal just show or hide
                //         // it as you need to.
                //         modal.element.modal();
                //     });
                //
                // };

                $scope.$watch('orderDetails.note', function(newValue, oldValue) {
                    console.log('orderDetails', orderDetails);
                    if (newValue !== oldValue) {
                        $scope.save();
                    }
                });

                $scope.$watch('orderDetails.paymentNote', function(newValue, oldValue) {
                    if (newValue !== oldValue) {
                        $scope.$save();
                    }
                });

                $scope.printInvoice = function() {
                    alert('coming soon');
                };

                $scope.emailInvoice = function() {
                    alert('coming soon');
                };

                $scope.printReceipt= function() {
                    alert('coming soon');
                };

                $scope.emailReceipt = function() {
                    alert('coming soon');
                };

                $scope.savePaymentStatus = function(status){

                    $scope.orderDetails.statusDatestamp =  Math.floor(Date.now() / 1000);

                    $scope.save();

                    $scope.editPaymentStatusMode = false;

                };

                $scope.cancelEditPaymentStatus = function() {

                    $scope.editPaymentStatusMode = false;

                };

                $scope.editPaymentStatus = function() {

                    $scope.editPaymentStatusMode = true;

                };

                $scope.cancelEditTotal = function() {

                    $scope.save();

                    $scope.editTotalMode = false;

                };

                $scope.editTotal = function() {

                    $scope.editTotalMode = true;

                };

                $scope.saveOrderStatus = function(status){

                    $scope.orderDetails.orderStatusDatestamp =  Math.floor(Date.now() / 1000);

                    $scope.save();

                    $scope.editOrderStatusMode = false;

                };

                $scope.cancelEditOrderStatus = function() {

                    $scope.editOrderStatusMode = false;

                };

                $scope.editOrderStatus = function() {

                    $scope.editOrderStatusMode = true;

                };

                $scope.$watch('orderDetails.status', function(newValue, oldValue) {

                    if(oldValue !== newValue){
                        $scope.savePaymentStatus();
                    }

                });

                $scope.$watch('orderDetails.orderStatus', function(newValue, oldValue) {

                    if(oldValue !== newValue){
                        $scope.saveOrderStatus();
                    }

                });

        }]);

    })();
